// test2608
(2608 && 0);
